<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.discountCodeNav.overview')" link="discountCodes" />
    <item-nav-group v-if="!isEmpty(discountCodes)" :open="true" :label="$t('layout.nav.admin.discountCodeNav.discountCodes')">
      <template v-for="discountCode in discountCodes" v-if="!discountCode.deleted">
        <item-nav-group-item :label="discountCode.code || '-'" :params="routeParams(discountCode.id)" :key="discountCode.id" link="discountCode" />
      </template>
    </item-nav-group>

    <!--    <item-nav-group v-if="!isEmpty(deletedDiscountCodes)" :label="$t('layout.nav.admin.discountCodeNav.deletedDiscountCodes')">-->
    <!--      <item-nav-group-item v-for="discountCode in deletedDiscountCodes"-->
    <!--                           :label="discountCode.code || '-'"-->
    <!--                           :params="routeParams(discountCode.id)"-->
    <!--                           :key="discountCode.id"-->
    <!--                           link="discountCode" />-->
    <!--    </item-nav-group>-->

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, keyBy, sortBy } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';
import HotelSettingsMixin from '../../../../../mixins/HotelSettingsMixin';

export default {
  name: 'DiscountCodeNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      discountCodes: [],
    };
  },

  computed: {
    deletedDiscountCodes: function () {
      return this.discountCodes.filter(it => it.deleted === true);
    },
  },

  created: function () {
    this.updateDiscountCodes();

    this.$serviceBus.$on('discountCode.list', (data) => {
      if (isNil(data)) {
        this.updateDiscountCodes();
      } else {
        this.discountCodes = sortBy(data, ['code']);
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    updateDiscountCodes() {
      this.axios.get(this.serviceUrls.discountCode.list(this))
        .then((response) => {
          this.discountCodes = sortBy(response.data.data, ['code']);
        });
    },
    routeParams(discountCodeId) {
      return {
        discountCodeId: discountCodeId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/DiscountCodeNav.vue